//抽奖PC WAP公用数据
import { ck, $subscriber } from "fire-wind-water";
import ws from "../services/webinar";

export function buildQuestionData(data) {
  return Object.assign(
    {
      src: "",
      isShow: false,
      webinarInfo: {},
      randomNum: window.questionTimeout || 30
    },
    data
  );
}

export function buildQuestionMethod(otherMethods) {
  return Object.assign(
    {
      getQuestion(id, type) {
        let self = this;
        if(type=='shoudong'){
          console.log('self',self);
          let url = window.location.href
          url = url.replace(this.$route.fullPath,"question")
          self.src = url
          self.isShow = true;
        }else {
          ws.isAllQuestionJoin({
            "quesitonary": [this.webinarInfo.customFieldObject.questionId, this.webinarInfo.customFieldObject.questionId2],
            globalUserId: ck.cookie("globalUserId"),
          }).subscribe(res => {
            const hasJoin= res.content.checkAction == '1'
            if(hasJoin){
              $subscriber.emit('setHasParticipation');
            }else {
              console.log('self',self);
              let url = window.location.href
              url = url.replace(this.$route.fullPath,"question")
              self.src = url
              var random = Math.ceil(Math.random() * self.randomNum) * 1000;
              setTimeout(function (){        self.isShow = true;},random)
            }
          })
        }


      },
      close() {
        this.isShow = false;
      },

    },
    otherMethods
  );
}

export function mounted(model) {
  let self = model;

  $subscriber.subscribe("onPublishQuestionnaire", data => {
    self.getQuestion(data[0].id);
  });
  $subscriber.subscribe("onUserOnlineNum", data => {
    self.randomNum = data.questionnaireDelay.time;
  });
  $subscriber.subscribe("onQuestionnaire", data => {
    if (data.length > 0) {
      self.getQuestion(data[0].id);
    }
  });
  $subscriber.subscribe("webinarInfo", data => {
    self.webinarInfo = data;
  });
  $subscriber.subscribe("showQuestion", data => {
    if (data == "shoudong") {
      if (self.webinarInfo.questionaryId) {
        self.getQuestion(self.webinarInfo.questionaryId, "shoudong");
      } else {
        // $subscriber.emit("showPopup", { message: "主办方暂时没有设置问卷！" });
      }
    } else {
      if (self.webinarInfo.questionaryId) {
        self.getQuestion(self.webinarInfo.questionaryId);
      } else {
        // $subscriber.emit("showPopup", { message: "主办方暂时没有设置问卷！" });
      }
    }
  });
  $subscriber.subscribe("onCloseQuestionnaire", () => {
    self.close();
  });
}
